import { useDispatch, useSelector } from "react-redux";
import { AppState } from "../../../common/store/combinedReducer";
import HeaderComponent from "../header/header";
import "./dashboard.scss";
import LeftContainer from "./LeftContainer/leftContainer";
import {
  getAssignedRoles,
  getCSRFToken,
  getDetails,
  getPermissions,
  setCSRFToken,
  setLoading,
  setLoggedIn,
  setSelectedView,
  setVmIdNotification,
} from "../../store/action";
import { useEffect, useState } from "react";
import { Button, Loader, Modal } from "@scuf/common";
import { useNavigate } from "react-router-dom";
import AuthProvider from "../../../common/authentication/authService";
import config from "../../../common/authentication/config";
import { handleRefresh } from "../../../common/utility/Dashboard/utility";

export default function Dashboard() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const selectedView = useSelector((state: AppState) => {
    return state.reducer.selectedView;
  });
  const plantName = useSelector((state: AppState) => {
    return state.reducer.plantName;
  });
  const loading = useSelector((state: AppState) => {
    return state.reducer.loading;
  });
  const activePage = useSelector((state: AppState) => {
    return state.reducer.activePage;
  });
  const permissions = useSelector((state: AppState) => {
    return state.reducer.permissions;
  });
  const orgDataStatus = useSelector((state: AppState) => {
    return state.reducer.orgDataStatus;
  });
  const permissionStatus = useSelector((state: AppState) => {
    return state.reducer.permissionStatus;
  });
  const selectedPlant = useSelector((state: AppState) => {
    return state.reducer.selectedPlant;
  });
  const csrf = useSelector((state: AppState) => {
    return state.reducer.csrf;
  });
  const csrfStatus = useSelector((state: AppState) => {
    return state.reducer.csrfStatus;
  });
  const vmIdNotification = useSelector((state: AppState) => {
    return state.reducer.vmIdNotification;
  });
  const orgsDropDownData = useSelector((state: AppState) => {
    return state.reducer.orgsDropDownData;
  });
  const assignedRoles = useSelector((state: AppState) => {
    return state.reducer.assignedRoles;
  });
  const assignedRolesStatus: any = useSelector((state: AppState) => {
    return state.reducer.assignedRolesStatus;
  });
  const selectedTenant: any = useSelector((state: AppState) => {
    return state.reducer.selectedTenant;
  });
  const [getRefreshToken, setRefreshtoken] = useState(false);
  const [token, setToken] = useState("");
  const [isTabActive, setTabActive] = useState(true);
  const [intervalID, setIntervalID] = useState(0);
  let sessionTimer: any;
  let timer: any = 0;
  let popupTimer: any = 0;
  const refreshToken = () => {
    clearTimeout(intervalID);
    popupTimer = 0;
    setRefreshtoken(false);
  };

  useEffect(() => {
    if (
      permissions?.length > 0 &&
      localStorage.getItem("access_token") !== undefined &&
      permissionStatus !== 500
    ) {
      const selectedIndex = activePage;
      if (
        orgDataStatus === 0 &&
        orgsDropDownData.length > 0 &&
        orgDataStatus !== undefined
      ) {
        const selectedPlantToFetch = orgsDropDownData[selectedIndex].value;
        if (
          vmIdNotification !== null &&
          selectedPlant === selectedPlantToFetch
        ) {
          fetchDetails(selectedPlant, vmIdNotification);
        } else if (
          vmIdNotification === null &&
          selectedPlant === selectedPlantToFetch
        ) {
          fetchDetails(selectedPlant);
          checkUserRole(selectedPlant);
        } else {
          dispatch(setLoggedIn(false));
        }
      } else if (orgDataStatus === 0) {
        fetchDetails(selectedPlant);
      } else if (orgDataStatus !== 0) {
        dispatch(setLoggedIn(false));
      }
    } else if (
      permissionStatus !== 0 &&
      (permissions === null ||
        (permissions?.length <= 0 &&
          localStorage.getItem("access_token") !== undefined) ||
        permissionStatus === 500)
    ) {
      dispatch(setLoggedIn(false));
      dispatch(setVmIdNotification(null));
      navigate("/loginFailed");
    }
  }, [permissions, orgDataStatus, vmIdNotification, selectedPlant, activePage]);

  const checkUserRole = (selectedPlant: any) => {
    if (assignedRolesStatus === 0 && assignedRoles?.length === 0) {
      dispatch(
        getAssignedRoles({
          authorization: localStorage.getItem("access_token"),
          siteId: selectedPlant,
          tenantId: selectedTenant,
        })
      );
    }
  };

  const fetchDetails = (orgs: string, vmId?: string) => {
    if (vmId) {
      dispatch(
        getDetails({
          authorization: localStorage.getItem("access_token"),
          orgs,
          vmId,
        })
      );
    } else {
      dispatch(
        getDetails({
          authorization: localStorage.getItem("access_token"),
          orgs,
        })
      );
    }
    dispatch(setLoggedIn(true));
  };

  useEffect(() => {
    if (csrfStatus === 200 || csrfStatus !== 0) {
      const sub: any = AuthProvider().getUserId();
      dispatch(setCSRFToken({ status: 0, data: false }));
      if (sub && csrf === true && permissions?.length === 0) {
        dispatch(
          getPermissions({
            userSub: sub,
            authorization: localStorage.getItem("access_token"),
          })
        );
      } else if (csrf === false) {
        setTimeout(() => {
          navigate("/loginFailed");
        }, 500);
      } else {
        dispatch(setLoading(false));
      }
    } else if (csrfStatus !== 200 && csrfStatus !== 0) {
      setTimeout(() => {
        navigate("/loginFailed");
      }, 500);
    }
  }, [csrfStatus, csrf]);

  // const handleRefresh = async (isRefreshed: boolean) => {
  //   if (isRefreshed == true) AuthProvider().clearCookie("XSRF-TOKEN");
  //   else {
  //     setToken("refreshed");
  //   }
  //   AuthProvider()
  //     .getRefreshToken()
  //     .then((resp: any) => {
  //       const tokenData = resp?.access_token;
  //       setToken("notRefreshed");
  //       if (tokenData && resp && isRefreshed == true) {
  //         dispatch(
  //           getCSRFToken({
  //             authorization: localStorage.getItem("access_token"),
  //           })
  //         );
  //       }
  //     });
  // };
  useEffect(() => {
    if (
      localStorage.getItem("logged_user") === null ||
      localStorage.getItem("logged_user") === JSON.stringify(false)
    ) {
      localStorage.setItem("logged_out_from", "dashboard /");
      navigate("/");
    } else {
      localStorage.setItem("logged_user", JSON.stringify(true));
      const selectedViewVal = {
        selectedView: "Dashboard",
        plantName,
        activePage,
      };
      dispatch(setSelectedView(selectedViewVal));
      if (permissions?.length === 0) {
        dispatch(setLoading(true));
        handleRefresh(true, dispatch, setToken, "Dashboard");
      }
    }
    window.addEventListener("focus", handleFocus);
    window.addEventListener("blur", handleBlur);
    dispatch(setVmIdNotification(null));
  }, []);
  const handleFocus = () => {
    localStorage.setItem("activeTab", selectedView);
    setTabActive(true);
    clearTimeout(timer);
  };

  const handleBlur = () => {
    setTabActive(false);
    timer = setTimeout(() => {
      if (localStorage.getItem("activeTab") == selectedView) {
        setRefreshtoken(true);
      }
    }, config.INTERVAL); // 2hours
  };

  useEffect(() => {
    if (isTabActive === false) {
      if (getRefreshToken === true) {
        popupTimer = setTimeout(() => {
          // if (clicked === false)
          setRefreshtoken(false);
          localStorage.setItem("logged_out_from", "Dashboard");
          navigate("/logout");
        }, 60 * 1000);
        setIntervalID(popupTimer);
      }
    }
  }, [getRefreshToken, isTabActive]);

  const sessionExtendPopup = () => {
    return (
      <Modal
        className="userDeleteModal"
        closeIcon={false}
        open={getRefreshToken}
        closeOnDimmerClick={false}
        closeOnDocumentClick={false}
        data-testid="user-delete-modal"
      >
        <Modal.Header className="">You have been idle!</Modal.Header>
        <Modal.Content className="confirmModal">
          <span className="modal-text-vm">You will logged out in 1 minute</span>
        </Modal.Content>
        <Modal.Footer>
          <Button
            type="primary"
            size="small"
            content="Stay"
            className="save-secondary"
            onClick={refreshToken}
          />
        </Modal.Footer>
      </Modal>
    );
  };
  const renderViewSelected = () => {
    localStorage.setItem("activeTab", selectedView);
    switch (selectedView) {
      case "UserManagement":
        navigate("/dashboard/userManagement");
        return;
      // return <UserManagement />
      case "DataManagement":
        navigate("/dashboard/dataManagement");
        return;
      // return <DataManagement />
      case "Dashboard":
        // default:
        return (
          <div className="dashboard-main" data-testid="dashboard-container">
            <HeaderComponent />
            <div className="dashboard-container">
              <div className="left-container" data-testid="left-container">
                <LeftContainer token={token} setToken={setToken} />
              </div>
            </div>
          </div>
        );
    }
  };

  return (
    <div>
      {sessionExtendPopup()}
      {loading ? (
        <Loader id="mock-loader" overlayColor="rgba(0,0,0,0.2)">
          <div className="placeholder" />
        </Loader>
      ) : null}
      {renderViewSelected()}
    </div>
  );
}
